<template>

<div class="text" v-html="html" :class="{'is-white': white}"></div>

</template>

<script>

export default {

	props: ['html', 'white']

}

</script>

<style>


.text a[data-link-type="2"] {
	padding: 0px 32px;
    height: 48px;
	line-height: 44px;
    border-radius: 24px;
    border: 2px solid var(--primary-color);
    font-size: 18px;
    font-weight: 700;
    display: inline-block;
    color: #343434;
    transition: border-color 300ms 
	ease-in-out, background-color 300ms 
	ease-in-out;
}

.text a[data-link-type="2"]:hover {
	background-color: var(--primary-color);
	text-decoration: none;
    color: #fff;
}

</style>
